import Market from '@core/models/struct/Market';
import Tournament from '@core/models/struct/Tournament';
import Category from '@models/struct/Category';
import MarketGroupInfo from '@models/struct/MarketGroupInfo';
import MarketTree from '@models/struct/MarketTree';
import OddType from '@models/struct/OddType';
import Sport from '@models/struct/Sport';

export const StructType = {
    Sports: 'sports',
    Tournaments: 'tournaments',
    Categories: 'categories',
    Markets: 'markets',
    OddTypes: 'oddTypes',
    MarketTree: 'marketTree',
    MarketGroupInfos: 'marketGroupInfos',
} as const;
export type StructType = typeof StructType[keyof typeof StructType];

type StructTypeConfig = Record<StructType, Record<number | string, unknown>>;

export default interface Struct extends StructTypeConfig {
    [StructType.Sports]: Record<number, Sport>;
    [StructType.Tournaments]: Record<number, Tournament>;
    [StructType.Categories]: Record<number, Category>;
    [StructType.Markets]: Record<number, Market>;
    [StructType.OddTypes]: Record<number, OddType>;
    [StructType.MarketTree]: MarketTree;
    [StructType.MarketGroupInfos]: Record<number, MarketGroupInfo>;
}
